module.exports = __webpack_public_path__ + "img/bank-assert-rule.2cd1f946.svg";